import classNames from 'classnames';

import { ExploreBlockType } from '@addmile/backend-client';

type CreateCollectionHeaderProps = {
  onCreateCollection: () => void;
  onCreateBlock: (type: ExploreBlockType) => void;
};

const TYPE_LABELS: { type: ExploreBlockType; label: string; icon: string }[] = [
  {
    type: ExploreBlockType.Article,
    label: 'Article',
    icon: '/icons/previewer/article.svg',
  },
  {
    type: ExploreBlockType.Action,
    label: 'Action',
    icon: '/icons/previewer/action.svg',
  },
  {
    type: ExploreBlockType.Quiz,
    label: 'Quiz',
    icon: '/icons/previewer/quiz.svg',
  },
  {
    type: ExploreBlockType.Practice,
    label: 'Practice',
    icon: '/icons/previewer/practice.svg',
  },
  {
    type: ExploreBlockType.Video,
    label: 'Video',
    icon: '/icons/previewer/video.svg',
  },
  {
    type: ExploreBlockType.Reflect,
    label: 'Reflect',
    icon: '/icons/previewer/reflect.svg',
  },
  {
    type: ExploreBlockType.MythBuster,
    label: 'Myth Buster',
    icon: '/icons/previewer/myth-buster.svg',
  },
  {
    type: ExploreBlockType.MissingPiece,
    label: 'Missing Piece',
    icon: '/icons/previewer/missing-piece.svg',
  },
];

const CreateCollectionHeader = ({
  onCreateCollection,
  onCreateBlock,
}: CreateCollectionHeaderProps) => {
  return (
    <>
      <div className="mb-6 flex flex-col gap-4 items-start bg-white-100 rounded-2xl p-4">
        <h2 className="text-2xl font-semibold text-neutral-90">Create new</h2>

        <div className="flex gap-4">
          <button
            onClick={onCreateCollection}
            className="w-[200px] rounded-2xl border-indigo-200 text-indigo-700 hover:bg-primary-100 transition text-left p-6 text-center bg-primary-10 border border-neutral-20 hover:shadow-s"
          >
            <div className="text-5xl leading-none text-primary-50">＋</div>
            <div className="mt-2 text-lg font-semibold">New Collection</div>
          </button>

          <div className="flex flex-wrap gap-4">
            {TYPE_LABELS.map((t) => (
              <button
                key={t.type}
                onClick={() => onCreateBlock(t.type)}
                className={classNames(
                  'h-[60px] min-w-[144px] rounded-2xl bg-white hover:bg-gray-50 transition px-6 text-center flex items-center justify-center gap-2 hover:shadow-s border border-neutral-20',
                )}
              >
                {t.icon && <img src={t.icon} alt={t.label} className="w-8 h-8" />}
                <div className="text-base font-semibold text-neutral-90">{t.label}</div>
              </button>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default CreateCollectionHeader;
